import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import attr from 'ember-data/attr';
import { belongsTo } from 'ember-data/relationships';
import hasLiquid from 'cio/utils/validators/liquid';
import EnvironmentModel from 'cio/models/environment';
import Model from '@ember-data/model';

export type IdentityVerifiedState = 'verified' | 'unverified' | 'undetermined';
export type IdentityTemplateType = 'email' | 'twilio';

export default class IdentityModel extends Model {
  @attr('string', { defaultValue: '' }) name!: string;
  @attr('string', { defaultValue: '' }) email!: string;
  @attr('string') phone!: string;
  @attr('string') address!: string;
  @attr('string') templateType!: IdentityTemplateType;
  @attr('boolean') autoGenerated!: boolean;
  @attr('string') verified!: IdentityVerifiedState;

  @belongsTo('environment', { async: false, inverse: 'identities' }) environment!: EnvironmentModel;

  @computed('name', 'phone')
  get nameAndPhone(): string {
    return [this.name, this.phone].reject(isEmpty).join(': ');
  }

  @computed('email')
  get emailDomain() {
    return this.email.split('@')[1] || '';
  }

  @computed('email')
  get hasDynamicEmail() {
    return hasLiquid(this.email);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    identity: IdentityModel;
  }
}
